import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Perfil } from 'src/app/domain/model/catalogo/perfil';

/**
 * Adaptador HTTP: HttpPerfilRepository
 *
 * Servicio para comunicación HTTP con el catálogo de Perfiles.
 * Endpoint: GET /api/servicios/perfiles
 */
@Injectable({ providedIn: 'root' })
export class HttpPerfilRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/perfiles`;

  /** Lista todos los perfiles activos. */
  async listarActivos(): Promise<Perfil[]> {
    return firstValueFrom(
      this.http.get<Perfil[]>(this.baseUrl)
    );
  }
}
